// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebarAll.js
import React, { useState, useEffect } from 'react';
import EventDialogServiceTimeSidebar from './EventDialogServiceTimeSidebar';
import EventDialogServiceTimeSidebar_Spa from './EventDialogServiceTimeSidebar_Spa';

function getCurrentTimeString() {
  const now = new Date();
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

const EventDialogServiceTimeSidebarAll = (props) => {
  const [stateSidebarShow] = useState(2); // Default to 1 for testing Mode 1
  const [selectedTime, setSelectedTime] = useState('');
  const [serviceTimeFrom, setServiceTimeFrom] = useState('');
  const [serviceTimeTo, setServiceTimeTo] = useState('');

  const handleSelectedBookingTimeForMode1 = () => {
    const timeNow = getCurrentTimeString();
    console.log('Mode=1 => forcing time to now =>', timeNow);
    setSelectedTime(timeNow);
    setServiceTimeFrom(timeNow);
    setServiceTimeTo(timeNow);
  };

  const handleSelectedBookingTimeForMode2 = (time) => {
    console.log('Mode=2 => user picked time =>', time);
    setSelectedTime(time);
    setServiceTimeFrom(time);
    setServiceTimeTo(time);
  };

  const refreshServiceTimes = () => {
    if (stateSidebarShow === 1) {
      const timeNow = getCurrentTimeString();
      const timeNowSlots = [{ time: timeNow, statusHH: 'Available' }];
      props.setReserveServiceTimes(timeNowSlots);
      setSelectedTime(timeNow);
      setServiceTimeFrom(timeNow);
      setServiceTimeTo(timeNow);
      sessionStorage.setItem('reserveServiceTimes', JSON.stringify(timeNowSlots));
      console.log('Mode=1 => Refreshed with Time Now:', timeNowSlots);
    } else if (stateSidebarShow === 2) {
      props.fetchReserveServiceTimes(props.selectedDate, props.priceID, (slots) => {
        props.setReserveServiceTimes(slots);
      });
      console.log('Mode=2 => Fetched reserve times');
    }
  };

  const handleSubmitWithTime = (paymentAmount) => {
    if (stateSidebarShow === 1) {
      handleSelectedBookingTimeForMode1();
    }
    console.log('Submitting with time =>', selectedTime);
    props.handleSubmit(paymentAmount, selectedTime, serviceTimeFrom, serviceTimeTo);
    refreshServiceTimes();
  };

  useEffect(() => {
    props.setRefreshServiceTimes(() => refreshServiceTimes);
  }, [props.selectedDate, props.priceID, stateSidebarShow]);

  useEffect(() => {
    refreshServiceTimes();
  }, [props.selectedDate, props.priceID, stateSidebarShow]);

  return (
    <>
      {stateSidebarShow === 1 && (
        <EventDialogServiceTimeSidebar
          {...props}
          handleSelectedBookingTime={handleSelectedBookingTimeForMode1}
          handleSubmit={handleSubmitWithTime}
          selectedTime={selectedTime}
          serviceTimeFrom={serviceTimeFrom}
          serviceTimeTo={serviceTimeTo}
          refreshServiceTimes={refreshServiceTimes}
        />
      )}
      {stateSidebarShow === 2 && (
        <EventDialogServiceTimeSidebar_Spa
          {...props}
          handleSelectedBookingTime={handleSelectedBookingTimeForMode2}
          handleSubmit={handleSubmitWithTime}
          selectedTime={selectedTime}
          serviceTimeFrom={serviceTimeFrom}
          serviceTimeTo={serviceTimeTo}
          refreshServiceTimes={refreshServiceTimes}
        />
      )}
    </>
  );
};

export default EventDialogServiceTimeSidebarAll;